"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const context_1 = require("src/context/context");
const TranslationProvider_1 = require("src/providers/TranslationProvider");
const CommentModal_1 = tslib_1.__importDefault(require("src/components/modal/CommentModal"));
const ExpirationDeclineCommentModal = (props) => {
    const { translate } = (0, TranslationProvider_1.useTranslation)();
    const { toast } = (0, context_1.useToastContext)();
    return ((0, jsx_runtime_1.jsx)(CommentModal_1.default, { closeModal: () => props.setShowDeclineComment(false), saveComments: async (message) => {
            const res = await props.declineExpirationDate(props.expirationDateId, message);
            res.errors === null
                ? toast.success(translate('submission_deadline_decline_successfully', 'წარდგინების ვადის უარყოფა განხორციელდა წარმატებით'))
                : res.errors.forEach(el => toast.danger(el.message));
            props.setShowDeclineComment(false);
        }, isLoading: props.isDecliningExpirationDate, buttonText: '\u10E3\u10D0\u10E0\u10E7\u10DD\u10E4\u10D0', buttonColorType: 'danger' }));
};
exports.default = ExpirationDeclineCommentModal;
